export default "__VITE_ASSET__1f33fa67__"